// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PPushpinOutlinedSvg from "@fishx/icons-svg/es/asn/PPushpinOutlined";
import FishxIcon from '../components/FishxIcon';

var PPushpinOutlined = function PPushpinOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PPushpinOutlinedSvg
  }));
};

PPushpinOutlined.displayName = 'PPushpinOutlined';
export default React.forwardRef(PPushpinOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PPushpinOutlined.js
// module id = 3555
// module chunks = 0